import React from 'react';
import { Eye, EyeOff, Mail, Lock, Loader } from 'lucide-react';
import { useLanguage } from 'hooks/useLanguage';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';

const LoginForm = ({
  formData,
  onInputChange,
  showPassword,
  onTogglePassword,
  onSubmit,
  isLoading,
  onForgotPassword
}) => {
  const { t } = useLanguage();

  return (
    <form onSubmit={onSubmit} className="space-y-6">
      {/* Email Input */}
      <div className="space-y-2">
        <div className="relative">
          <Mail className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={formData?.email}
            onChange={onInputChange}
            className="pl-12 py-4 bg-gray-50 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 text-gray-900 placeholder-gray-500 w-full"
            placeholder="you@example.com"
          />
        </div>
      </div>

      {/* Password Input */}
      <div className="space-y-2">
        <div className="relative">
          <Lock className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <Input
            id="password"
            name="password"
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            required
            value={formData?.password}
            onChange={onInputChange}
            className="pl-12 pr-12 py-4 bg-gray-50 border border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-20 text-gray-900 placeholder-gray-500 w-full"
            placeholder="At least 8 characters"
          />
          <button
            type="button"
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
            onClick={onTogglePassword}
          >
            {showPassword ? (
              <EyeOff className="w-5 h-5" />
            ) : (
              <Eye className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>

      {/* Forgot Password Link */}
      <div className="flex justify-end">
        <button
          type="button"
          onClick={onForgotPassword}
          className="text-sm text-blue-600 hover:text-blue-700 hover:underline transition-colors font-medium"
        >
          Forgot password?
        </button>
      </div>

      {/* Submit Button */}
      <Button
        type="submit"
        disabled={isLoading}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-base shadow-lg"
      >
        {isLoading ? (
          <>
            <Loader className="w-5 h-5 animate-spin" />
            Signing in...
          </>
        ) : (
          'Login'
        )}
      </Button>
    </form>
  );
};

export default LoginForm;